// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sortControlStyles } from "@bg/Overrides/Widgets/MyLists/MyListsSortControl";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import translate from "@insite/client-framework/Translate";
import { css } from "styled-components";

sortControlStyles.select = {
    cssOverrides: {
        formField: css`
            flex-direction: row;
            align-items: center;
            label {
                width: auto;
                font-weight: ${fontConfig.weight.bold};
                font-size: ${fontConfig.fontSize.small}px;
                margin-right: 8px;
                white-space: nowrap;
            }
            @media (max-width: 650px) {
                flex-direction: column;
                align-items: flex-start;
            }
        `,
        formInputWrapper: css`
            margin-top: 0 !important;
        `,
        inputSelect: css`
            font-size: ${fontConfig.fontSize.small}px;
            height: 32px;
        `,
    },
    iconProps: {
        css: css`
            &&&&&& {
                top: auto;
            }
        `,
    },
    label: translate("Sort By"),
};
